import React, { useRef } from 'react';
import { Body, Container, EntryAnimation, Heading } from '../../atoms';
import { LabeledCallToAction, PatternFigure } from '../../molecules';
export default function LargeHero(param) {
    var title = param.title, description = param.description, primaryImage = param.primaryImage, secondaryImage = param.secondaryImage, label = param.label, action = param.action, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: LargeHero.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6 md:gap-11 md:grid-cols-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6 md:gap-8"
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h1",
        variant: "h1"
    }, title)), /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.1
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "md",
        className: "prose"
    }, description)), !!(label && action) && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.2
    }, /*#__PURE__*/ React.createElement(LabeledCallToAction, {
        label: label,
        action: action
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "order-first md:order-last"
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.05
    }, /*#__PURE__*/ React.createElement(PatternFigure, {
        variant: "1",
        images: [
            primaryImage,
            secondaryImage
        ]
    })))));
}

//# sourceMappingURL=LargeHero.js.map